import ras from '../../Assets/Images/ras.png';
import lab from '../../Assets/Images/lab.png';
import hacktoberfest from '../Images/hacktoberfest.png';

export const OpenSourceData = [
  {
    title: 'Animating Buttons',
    link: 'https://getbuttons.tech/',
    imageSrc: lab,
    headline: 'Explore Amazing Buttons animation for your next project.',
    description:
      'There are so many animated buttons for your next website, I created this website as an intiative under GDSC-DYPCOE',
    color: '#2e070d'
    // width: "200px",
    // height: "200px",
    // fontColor: '#000',
    // textShadow: '1px 1px 1px #000'
  },
  {
    title: 'React Awesome Shapes',
    link: 'https://awesomeshapes.netlify.app/',
    imageSrc: ras,
    headline: 'Insert Awesome Shapes into Your React Site with Ease.',
    description:
      'There are so many amazing shapes like star, cross, donut, circle, etc which one can use as a component in react and display it as their requirements!',
    color: '#111827'
    // width: "200px",
    // height: "200px",
  }
  // {
  //   title: 'Hacktoberfest 2021',
  //   link: 'https://hacktoberfest.digitalocean.com/',
  //   headline: 'Completed Hacktoberfest 2021',
  //   description:
  //     "Hacktoberfest is a yearly event to encourage people to contribute to open source in October. It's a celebration of community, learning and giving back—topped off by DigitalOcean thanking participants. ",
  //   imageSrc: hacktoberfest,
  //   color: '#f4f0e1',
  //   // width: "140px",
  //   // height: "140px",
  //   fontColor: '#0b3842',
  //   textShadow: '1px 1px 1px #fff'
  // }
];
